"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _table = _interopRequireDefault(require("../../../../../core/table"));
var _selectCode = _interopRequireDefault(require("../../../../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ExtendedTable = (0, _styledComponents.default)(_table.default)`
  margin-bottom: 10rem !important;
`;
var _ref = /*#__PURE__*/_react.default.createElement("td", {
  className: "text-xs-right"
}, "Bib:");
var _ref2 = /*#__PURE__*/_react.default.createElement("td", {
  className: "text-xs-right"
}, "Text:");
class ColourSelect extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(ExtendedTable, null, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.races.map(r => /*#__PURE__*/_react.default.createElement("tr", {
      key: r.id
    }, /*#__PURE__*/_react.default.createElement("td", null, r.raceName), _ref, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "BibColours",
      value: r.bibMain || '',
      onChange: this.props.setBibColour.bind(this, r.id, 'bibMain'),
      clearable: true,
      required: false
    })), _ref2, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "BibColours",
      value: r.bibText || '',
      onChange: this.props.setBibColour.bind(this, r.id, 'bibText'),
      clearable: true,
      required: false
    })))))));
  }
}
// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = ColourSelect;